/**
 * Defines the keys for different operations in the quote tool.
 * These keys can be used to identify and manage various operations such as price calculation and fetching extras.
 * Using an enum ensures type safety and consistency across the application when referring to these operations.
 * Using for instance, on LoadingService to set the loading state of a specific operation, and to check if all operations are loading.
 */
export enum OperationKey {
  prices = 'prices',
  extras = 'extras',
  extrasSummary = 'extras_summary',
}
